/**
 * ****************************************************************************
 * @description     :   RightHeader
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import React from 'react'

/**
 * Import child components
 */
import UserHeaderDropdown from './components/user-header-dropdown'
// import NotifyDropdown from './components/notify-dropdown'
import MenuDropdown from './components/menu-dropdown'

/**
 * Component for element on the right of header of template
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const RightHeader = () => {
    // const {notify} = props;
    return (
        <div className="nk-header-tools">
            <ul className="nk-quick-nav">
                {/* <NotifyDropdown listNotify={notify} /> */}
                <MenuDropdown />
                <UserHeaderDropdown />
            </ul>
        </div>
    );
};

export default React.memo(RightHeader);
